export const formatCurrency = (val) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(val);
};

// Note: Cette fonction génère un numéro temporaire
// Le vrai numéro séquentiel est généré côté serveur via getNextDocumentNumber
export const generateNumber = (type) => {
  const prefix = type === "quote" ? "DEV" : "FAC";
  const year = new Date().getFullYear();
  const month = String(new Date().getMonth() + 1).padStart(2, "0");
  return `${prefix}-${year}-${month}-TEMP`;
};

export const calculateTotals = (sections, globalSettings) => {
  let rawTotalHT = 0;
  let totalLabor = 0;
  let totalMaterial = 0;

  sections.forEach((section) => {
    section.items.forEach((item) => {
      const lineTotal = item.qty * item.price;
      rawTotalHT += lineTotal;
      if (item.nature === "labor") totalLabor += lineTotal;
      else totalMaterial += lineTotal;
    });
  });

  let discountAmount = 0;
  if (globalSettings.discountType === "percent") {
    discountAmount = rawTotalHT * (globalSettings.discountValue / 100);
  } else {
    discountAmount = globalSettings.discountValue;
  }

  const netTotalHT = Math.max(0, rawTotalHT - discountAmount);

  let rawTotalTVA = 0;
  sections.forEach((s) =>
    s.items.forEach((i) => (rawTotalTVA += i.qty * i.price * (i.vat / 100)))
  );

  const discountRatio = rawTotalHT > 0 ? netTotalHT / rawTotalHT : 1;
  const finalTVA = rawTotalTVA * discountRatio;

  return {
    rawTotalHT,
    discountAmount,
    netTotalHT,
    totalTVA: finalTVA,
    totalTTC: netTotalHT + finalTVA,
    totalLabor,
    totalMaterial,
  };
};

// Convertir un timestamp Firestore ou une date en objet Date
export const toDate = (timestamp) => {
  if (!timestamp) return new Date();
  if (timestamp.toDate) return timestamp.toDate();
  if (timestamp instanceof Date) return timestamp;
  return new Date(timestamp);
};

// Trier des documents par date de création (du plus récent au plus ancien)
export const sortDocumentsByDate = (docs) => {
  return docs.sort((a, b) => {
    const dateA = toDate(a.createdAt || a.date);
    const dateB = toDate(b.createdAt || b.date);
    return dateB - dateA;
  });
};

// Parser une valeur numérique avec support de la virgule française
export const parseNumber = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (!value || value === '' || value === '.') return defaultValue;
  
  const normalized = String(value).replace(',', '.');
  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? defaultValue : parsed;
};
